import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAverageSwingSpeed = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Group_125",
	"data-name": "Group 125",
	xmlns: "http://www.w3.org/2000/svg",
	width: 47.428,
	height: 25.746,
	viewBox: "0 0 47.428 25.746",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			id: "Path_265",
			"data-name": "Path 265",
			d: "M245.874,479.716c-.306-.139-.659-.293-1.037-.459a19.617,19.617,0,0,1-4.063-2.113c-1-.972-3.4-3.985-4.386-5.235a1.071,1.071,0,0,0-.522-.356c.045-.207.1-.425.175-.66.488-1.524,1.735-5.277,1.735-5.277a.9.9,0,0,0-1.714-.569c-.012.038-1.256,3.782-1.74,5.3a8.1,8.1,0,0,0-.416,2.655l-.041.076a2.862,2.862,0,0,1-1.714-.316,3.713,3.713,0,0,1-1.033-1.1c-.021-.033-.051-.059-.074-.092.154-.29.337-.664.577-1.152a26.1,26.1,0,0,0,1.432-5.569.9.9,0,1,0-1.785-.272A23.939,23.939,0,0,1,230,469.616c-.312.636-.5,1-.611,1.2a1.832,1.832,0,0,0-1.058.473,8.92,8.92,0,0,0-1.117,1.276,16.422,16.422,0,0,0-1.611,2.674c-.193.1-.519.362-1.383,1.478a.9.9,0,0,0-.144.833,5.617,5.617,0,0,0,3.33,3.08c2.332.987,10.148,3.4,10.517,3.511a17.632,17.632,0,0,0,3.97.506,7.878,7.878,0,0,0,2.813-.443,3.2,3.2,0,0,0,2.345-2.654A1.947,1.947,0,0,0,245.874,479.716Zm-15.954-9a.893.893,0,0,0-.284.058A.892.892,0,0,1,229.921,470.719Zm14.129,11.807c-1.69.662-4.667.131-5.632-.118-.08-.024-8.059-2.486-10.307-3.437a4.669,4.669,0,0,1-2.1-1.594c.2-.239.377-.445.477-.544l.126-.05a.906.906,0,0,0,.511-.508,13.524,13.524,0,0,1,1.55-2.64,6.334,6.334,0,0,1,.909-1.023c.013,0,.017.007.018.009h0a5.362,5.362,0,0,0,1.572,1.648,4.936,4.936,0,0,0,3.507.5.9.9,0,0,0,.616-.506c.077-.169.168-.347.258-.51,1.282,1.609,3.074,3.81,3.962,4.677a17.88,17.88,0,0,0,4.6,2.476c.369.161.713.312,1.013.448.123.056.122.113.121.146C245.242,481.73,244.918,482.186,244.049,482.527Z",
			transform: "translate(-220.805 -463.803)",
			fill: "current"
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "Group_121",
			"data-name": "Group 121",
			transform: "translate(0 23.94)",
			children: [
				/* @__PURE__ */ _jsx("g", {
					id: "Group_118",
					"data-name": "Group 118",
					transform: "translate(22.527)",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Path_266",
						"data-name": "Path 266",
						d: "M270.407,518.657H267.7a.9.9,0,1,1,0-1.805h2.708a.9.9,0,0,1,0,1.805Z",
						transform: "translate(-266.797 -516.852)",
						fill: "current"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					id: "Group_119",
					"data-name": "Group 119",
					transform: "translate(9.314)",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Path_267",
						"data-name": "Path 267",
						d: "M245.028,518.657h-6.606a.9.9,0,1,1,0-1.805h6.606a.9.9,0,0,1,0,1.805Z",
						transform: "translate(-237.519 -516.852)",
						fill: "current"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					id: "Group_120",
					"data-name": "Group 120",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Path_268",
						"data-name": "Path 268",
						d: "M220.491,518.657h-2.708a.9.9,0,0,1,0-1.805h2.708a.9.9,0,1,1,0,1.805Z",
						transform: "translate(-216.881 -516.852)",
						fill: "current"
					})
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "Group_124",
			"data-name": "Group 124",
			transform: "translate(29.936 4.467)",
			children: [/* @__PURE__ */ _jsx("g", {
				id: "Group_122",
				"data-name": "Group 122",
				children: /* @__PURE__ */ _jsx("path", {
					id: "Path_269",
					"data-name": "Path 269",
					d: "M296.228,477.105v-1.5a1.9,1.9,0,0,0-1.9-1.9H291.86a1.9,1.9,0,0,0-1.9,1.9v1.5a7.635,7.635,0,0,0-1.165.651.9.9,0,0,0,1.021,1.489,5.813,5.813,0,1,1-2.45,5.712l.923.924a.9.9,0,0,0,1.276-1.277l-2.4-2.4a.9.9,0,0,0-1.276,0l-2.4,2.4a.9.9,0,1,0,1.276,1.277l.8-.8a7.61,7.61,0,1,0,10.67-7.969Zm-4.465-.563V475.6a.1.1,0,0,1,.1-.1h2.465a.1.1,0,0,1,.1.1v.942a7.311,7.311,0,0,0-2.66,0Z",
					transform: "translate(-283.215 -473.701)",
					fill: "current"
				})
			}), /* @__PURE__ */ _jsx("g", {
				id: "Group_123",
				"data-name": "Group 123",
				transform: "translate(8.976 5.407)",
				children: /* @__PURE__ */ _jsx("path", {
					id: "Path_270",
					"data-name": "Path 270",
					d: "M304.007,485.683a.9.9,0,0,0-.9.9v4.026a.9.9,0,0,0,.264.639l2.166,2.167a.9.9,0,1,0,1.276-1.276l-1.9-1.9v-3.652A.9.9,0,0,0,304.007,485.683Z",
					transform: "translate(-303.104 -485.683)",
					fill: "current"
				})
			})]
		})
	]
});
const ForwardRef = forwardRef(SvgAverageSwingSpeed);
export { ForwardRef as ReactComponent };
